var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'ChatroomIndex'
      }
    }
  }, [_vm._v("聊天室管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("聊天室總覽")])], 1), _vm.newestNotification && _vm.$permissions.has(_vm.$permissions.consts.MY_NOTIFICATION_LATEST) ? _c('div', {
    staticClass: "ml-auto d-flex align-items-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'BranchNotificationDetail',
        params: {
          notification_id: _vm.newestNotification.id
        }
      }
    }
  }, [_c('i', {
    class: {
      'fa fa-envelope-o text-danger': !_vm.newestNotification.is_read,
      'fa fa-envelope-open-o text-black': _vm.newestNotification.is_read
    }
  }), _c('a', {
    staticClass: "ml-2 text-black",
    class: {
      'text-danger': !_vm.newestNotification.is_read
    }
  }, [_vm._v(" " + _vm._s(_vm.newestNotification.title) + " : " + _vm._s(_vm.format(new Date(_vm.newestNotification.publish_at), "MM/dd HH:mm")) + " ")])])], 1) : _vm._e()], 1)])]), _c('b-modal', {
    attrs: {
      "id": "modal-nickname",
      "title": "自訂暱稱",
      "ok-title": "儲存",
      "cancel-title": "取消",
      "centered": ""
    },
    on: {
      "ok": _vm.handleUpdateCustomerProfile,
      "hidden": _vm.handleCloseUpdateNickname
    }
  }, [_c('b-input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20",
      "placeholder": "自訂暱稱不會向對方公開"
    },
    model: {
      value: _vm.inputNickname,
      callback: function callback($$v) {
        _vm.inputNickname = $$v;
      },
      expression: "inputNickname"
    }
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modal-name",
      "title": "變更姓名",
      "ok-title": "儲存",
      "cancel-title": "取消",
      "centered": ""
    },
    on: {
      "ok": _vm.handleUpdateCustomerProfile
    }
  }, [_c('b-input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20",
      "placeholder": "變更姓名"
    },
    model: {
      value: _vm.customerProfile.name,
      callback: function callback($$v) {
        _vm.$set(_vm.customerProfile, "name", $$v);
      },
      expression: "customerProfile.name"
    }
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modal-personal-id",
      "title": "變更身份證字號",
      "ok-title": "儲存",
      "cancel-title": "取消",
      "centered": ""
    },
    on: {
      "ok": _vm.handleUpdateCustomerProfile
    }
  }, [_c('b-input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20",
      "placeholder": "變更身份證字號"
    },
    model: {
      value: _vm.customerProfile.personal_id,
      callback: function callback($$v) {
        _vm.$set(_vm.customerProfile, "personal_id", $$v);
      },
      expression: "customerProfile.personal_id"
    }
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modal-tags",
      "title": "編輯標籤",
      "ok-title": "儲存",
      "cancel-title": "取消",
      "centered": ""
    },
    on: {
      "ok": _vm.handleSaveTags
    }
  }, [_c('div', {
    staticClass: "border rounded p-1"
  }, [_vm._l(_vm.tags, function (tag, index) {
    return _c('b-badge', {
      key: tag.id,
      staticClass: "m-1",
      attrs: {
        "variant": "dark"
      }
    }, [_vm._v(" " + _vm._s(tag.name) + " "), _c('button', {
      staticClass: "btn btn-xs p-0",
      on: {
        "click": function click($event) {
          return _vm.handleClickRemoveTag(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove text-white"
    })])]);
  }), _c('b-input', {
    staticClass: "border-0",
    attrs: {
      "type": "text",
      "maxlength": "40",
      "placeholder": "輸入標籤"
    },
    on: {
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleEnterInputTag.apply(null, arguments);
      }, _vm.handleKeyUpInputTag],
      "blur": _vm.handleEnterInputTag
    },
    model: {
      value: _vm.inputTag,
      callback: function callback($$v) {
        _vm.inputTag = $$v;
      },
      expression: "inputTag"
    }
  })], 2), false ? [_c('div', {
    staticClass: "h6 mt-3"
  }, [_vm._v("現有標籤")]), _vm._l(_vm.tags, function (i) {
    return _c('b-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: false,
        expression: "false"
      }],
      key: i,
      staticClass: "m-1 text-dark",
      attrs: {
        "variant": "secondary",
        "size": "xs"
      }
    }, [_vm._v(" " + _vm._s(i) + " ")]);
  })] : _vm._e()], 2), _c('b-modal', {
    attrs: {
      "id": "modal-note",
      "title": "自訂筆記",
      "ok-title": "儲存",
      "cancel-title": "取消",
      "centered": ""
    },
    on: {
      "ok": _vm.handleSaveNote
    }
  }, [_c('b-textarea', {
    staticClass: "form-control",
    attrs: {
      "maxlength": "300",
      "placeholder": "你可於此新增用戶的相關資訊，且記事本中的資訊不會向對方公開",
      "rows": "10"
    },
    model: {
      value: _vm.customerProfile.note,
      callback: function callback($$v) {
        _vm.$set(_vm.customerProfile, "note", $$v);
      },
      expression: "customerProfile.note"
    }
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modal-showImg",
      "ok-title": "關閉",
      "centered": "",
      "ok-only": ""
    }
  }, [_c('img', {
    staticStyle: {
      "width": "480px"
    },
    attrs: {
      "src": _vm.currentImg
    }
  })]), _c('b-card', {
    staticClass: "chatroom d-flex flex-row",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    ref: "chatlist",
    staticClass: "chat-list position-relative d-flex flex-column border-right"
  }, [_c('div', {
    staticClass: "header px-3 pt-3 pb-2 border-bottom"
  }, [_c('div', {
    staticClass: "search mb-2"
  }, [_vm.canShowBranchSelector ? _c('b-form-select', {
    attrs: {
      "value": _vm.selectedBranch,
      "options": _vm.branchOptions,
      "disabled": _vm.changingBranch
    },
    on: {
      "change": _vm.handleChangeSelectedBranch
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null,
            "disabled": ""
          }
        }, [_vm._v("-- 選擇分店 --")])];
      },
      proxy: true
    }], null, false, 106926742)
  }) : _vm._e()], 1), _c('div', {
    staticClass: "search mb-2"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z"
    }
  })]), _c('b-form-input', {
    attrs: {
      "type": "search",
      "placeholder": "姓名搜尋"
    },
    on: {
      "input": _vm.keywordSearchDebounced
    },
    model: {
      value: _vm.keyword,
      callback: function callback($$v) {
        _vm.keyword = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "keyword"
    }
  })], 1), _vm.allowFilterCategory ? _c('ChatroomMultiselect', {
    attrs: {
      "title": "訊息類型",
      "filters": _vm.filterCategoryOptions,
      "showKeywordFilter": false,
      "selectedOptions": _vm.selectedCategoryFilter
    },
    on: {
      "click": _vm.handleSelectedCategory
    }
  }) : _vm._e(), _vm.allowFilterStatus ? _c('ChatroomMultiselect', {
    attrs: {
      "title": "處理狀態",
      "filters": _vm.statusOptions,
      "showKeywordFilter": false,
      "selectedOptions": _vm.selectedStatus
    },
    on: {
      "click": _vm.handleSelectedStatus
    }
  }) : _vm._e(), false ? _c('div', {
    staticClass: "filter"
  }, [_c('b-dropdown', {
    attrs: {
      "id": "dropdown-1",
      "text": "所有收件匣",
      "variant": "light"
    }
  }, _vm._l(_vm.filters, function (i) {
    return _c('b-dropdown-item', {
      key: i.id
    }, [_c('i', {
      class: [i.icon],
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(i.id) + " ")]);
  }), 1)], 1) : _vm._e()], 1), _c('b-list-group', {
    ref: "chatroomList",
    staticClass: "list list-group-flush",
    on: {
      "scroll": _vm.handleChatroomListScroll
    }
  }, [!_vm.initialized || _vm.changingBranch || _vm.changingFilter || _vm.keywordFilter ? _c('b-list-group-item', {
    staticClass: "empty"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1)]) : _vm.orderedChatrooms.length > 0 ? [_vm._l(_vm.orderedChatrooms, function (chatroom) {
    return _c('div', {
      key: chatroom.id,
      on: {
        "click": function click($event) {
          return _vm.selectChatroom(chatroom);
        }
      }
    }, [_c('ChatroomListItem', {
      attrs: {
        "role": "button",
        "chatroom": chatroom,
        "variant": _vm.chatroomId == chatroom.id ? 'secondary' : 'default',
        "staffID": _vm.staffId,
        "categories": _vm.categoryFilterOptions
      }
    })], 1);
  }), _vm.loading ? _c('div', {
    staticClass: "text-center mt-3 mb-3 loading-spinner"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1) : _vm._e()] : _c('b-list-group-item', {
    staticClass: "empty"
  }, [_c('div', {
    staticClass: "mt-3 text-dark small"
  }, [_vm._v("目前沒有名單")])])], 2)], 1), _c('div', {
    staticClass: "resizer",
    on: {
      "mousedown": _vm.resizeStart,
      "mouseup": _vm.resizeEnd
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('div', {
    staticClass: "chatbox flex-fill d-flex flex-column border-right"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "\n            d-flex\n            justify-content-between\n            px-3\n            py-2\n            pe-0\n            border-bottom\n            flex-wrap\n          "
  }, [_vm.selectedChatroom ? _c('div', {
    staticClass: "font-weight-bold"
  }, [_c('b-avatar', {
    staticClass: "mr-1"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.getStaffAvatar(_vm.selectedChatroom)
    }
  })]), _c('b-avatar', {
    staticClass: "mr-3"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.getCustomerAvatar(_vm.selectedChatroom)
    }
  })]), _vm._v(" " + _vm._s(_vm.getChatroomTitle(_vm.selectedChatroom, true)) + " ")], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex"
  }, [false ? _c('b-button', {
    staticClass: "m-1",
    on: {
      "click": function click() {
        var msg = Object.assign(_vm.messages[1]);
        _vm.messages = [msg].concat(_vm.messages);
        _vm.unread = true;
      }
    }
  }, [_vm._v(" Test Message")]) : _vm._e(), _vm.selectedChatroom ? _c('div', [_vm.canShowPinButton ? _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "variant": "".concat(_vm.isSelectedChatroomPinned ? 'warning' : 'outline-warning')
    },
    on: {
      "click": _vm.handleClickPin
    }
  }, [_vm._v(" " + _vm._s(_vm.isSelectedChatroomPinned ? "取消釘選" : "釘選") + " "), _c('i', {
    staticClass: "fa fa-thumb-tack",
    staticStyle: {
      "transform": "rotate(45deg)"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm.canShowStatusButtons ? [_c('b-dropdown', {
    ref: "Filter",
    staticClass: "filter col-6",
    attrs: {
      "variant": _vm.selectedChatroomStatusVariant
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('div', {
          staticClass: "flex-fill"
        }, [_vm._v(_vm._s(_vm.selectedChatroomStatusName))])];
      },
      proxy: true
    }], null, false, 1642692678)
  }, _vm._l(_vm.statusOptions, function (status) {
    return _c('div', {
      key: status.value,
      staticClass: "item py-1 px-3",
      on: {
        "click": function click($event) {
          return _vm.handleClickChangeStatus(status.value);
        }
      }
    }, [_c('span', {
      staticClass: "d-flex justify-content-between align-items-center"
    }, [_c('i', {
      class: "".concat(_vm.selectedChatroomStatus === status.value || !_vm.selectedChatroomStatus && status.value === 'not-setting' ? 'fa fa-check' : '', " mr-3"),
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('span', {
      class: "mb-0 px-3 py-2 badge badge-".concat(status.variant, " flex-fill cursor-pointer")
    }, [_vm._v(_vm._s(status.text))])])]);
  }), 0)] : _vm._e()], 2) : _vm._e(), false ? _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "variant": "outline-dark"
    },
    on: {
      "click": function click() {
        _vm.isMessageSearching = !_vm.isMessageSearching;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 搜尋")]) : _vm._e(), false ? _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "variant": "light"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in m-0",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), false ? _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "variant": "light"
    }
  }, [_c('i', {
    staticClass: "fa fa-check m-0 text-success",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 1)]), _vm.isMessageSearching ? _c('div', {
    staticClass: "search-message p-2 border-bottom d-flex"
  }, [_c('b-form-input', {
    staticClass: "flex-fill",
    attrs: {
      "size": "sm",
      "type": "search",
      "placeholder": "輸入搜尋內容"
    }
  }), _c('b-button', {
    staticClass: "btn btn-light ml-2",
    on: {
      "click": function click() {
        _vm.isMessageSearching = !_vm.isMessageSearching;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])], 1) : _vm._e()]), _c('div', {
    ref: "messages",
    staticClass: "message-container d-flex flex-column-reverse flex-fill px-3",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_vm._l(_vm.messages, function (message, idx) {
    return _c('div', {
      key: idx,
      class: ['message-box', 'my-2', _vm.isSender(message) && 'owner']
    }, [_vm.checkStrike(_vm.messages, idx) ? _c('div', {
      staticClass: "strike small text-muted pb-2"
    }, [_vm._v(" " + _vm._s(_vm.formatDateD(_vm.messages[idx].created_at)) + " ")]) : _vm._e(), _c('div', {
      staticClass: "message-wrapper"
    }, [_c('div', {
      staticClass: "d-flex align-items-start"
    }, [_c('b-avatar', {
      staticClass: "mr-2",
      attrs: {
        "src": message.sender.avatar_url
      }
    }), _c('div', [_c('small', {
      staticClass: "mb-1"
    }, [_vm._v(" " + _vm._s(_vm.messageSenderName(message)) + " ")]), message.type === 'image' ? [_c('div', {
      staticClass: "message image",
      class: {
        multiple: message.meta.images && message.meta.images.length > 1
      }
    }, _vm._l(message.meta.images, function (image, i) {
      return _c('div', {
        key: i,
        class: {
          expanded: message.meta.images.length & 1 && i === 0
        }
      }, [_c('img', {
        attrs: {
          "src": image.previewImageUrl
        },
        on: {
          "click": function click($event) {
            return _vm.showImageLightBox(image.originalContentUrl);
          }
        }
      })]);
    }), 0), _vm.canShowMultiDownload ? _c('div', {
      staticClass: "image-download-section"
    }, [_c('div', [_c('a', {
      staticClass: "download-all ml-2",
      staticStyle: {
        "display": "flex"
      },
      on: {
        "click": function click($event) {
          $event.preventDefault();
          _vm.selectedImageUrls = message.meta.images.map(function (image) {
            return image.originalContentUrl;
          });
          _vm.downloadMultiImages();
        }
      }
    }, [_c('div', [_c('svg', {
      staticStyle: {
        "width": "14px",
        "height": "14px",
        "margin-right": "10px"
      },
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke-width": "1.5",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "d": "M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
      }
    })])]), _c('div', [_vm._v(" 立即下載 ")])])])]) : _vm._e()] : message.type === 'file' ? _c('div', {
      staticClass: "message file py-2 px-3"
    }, [_c('a', {
      attrs: {
        "href": message.meta.fileUrl,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 384 512",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "d": "M374.6 310.6l-160 160C208.4 476.9 200.2 480 192 480s-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 370.8V64c0-17.69 14.33-31.1 31.1-31.1S224 46.31 224 64v306.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0S387.1 298.1 374.6 310.6z"
      }
    })])]), _c('div', {
      staticClass: "info"
    }, [_c('p', [_vm._v(_vm._s(message.meta.fileName))]), _c('p', [_vm._v(_vm._s(_vm.filesizeForHuman(message.meta.fileSize)))])])])]) : _c('div', {
      staticClass: "message py-2 px-3",
      domProps: {
        "innerHTML": _vm._s(_vm.manipulateMessage(message.content))
      }
    })], 2)], 1), _c('div', {
      staticClass: "\n                small\n                text-muted\n                mt-1\n                d-flex\n                align-items-end\n                justify-content-end\n              "
    }, [_c('ul', {
      staticClass: "list-unstyled read-list"
    }, [_vm._l(_vm.senders, function (sender) {
      return [_vm.senderIsRead(sender, message) ? _c('li', {
        key: sender.id,
        attrs: {
          "title": sender.name
        }
      }, [_c('b-avatar', {
        attrs: {
          "size": "1rem",
          "src": sender.avatar_url
        }
      })], 1) : _vm._e()];
    })], 2), _c('time', [_vm._v(_vm._s(_vm.format(new Date(message.created_at), "HH:mm")))])])])]);
  }), _vm.typingSenders.length ? _c('div', {
    staticClass: "typing-list"
  }, _vm._l(_vm.typingSenders, function (sender) {
    return _c('div', {
      key: sender.id,
      staticClass: "message-box my-2"
    }, [_c('div', {
      staticClass: "message-wrapper"
    }, [_c('div', {
      staticClass: "d-flex align-items-start"
    }, [_c('b-avatar', {
      staticClass: "mr-2",
      attrs: {
        "src": sender.avatar_url
      }
    }), _c('div', [_c('small', [_vm._v(_vm._s(sender.name))]), _c('div', {
      staticClass: "message py-2 px-3 mt-1"
    }, [_c('Typing')], 1)])], 1)])]);
  }), 0) : _vm._e(), _vm.nextCursor && !_vm.loading ? _c('div', {
    staticClass: "text-muted load-more"
  }, [_c('button', {
    staticClass: "btn btn-text",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.loadMore.apply(null, arguments);
      }
    }
  }, [_vm._v(" 載入更多 ")])]) : _vm._e(), _vm.loading ? _c('div', {
    staticClass: "text-center mt-3 mb-auto loading-spinner"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1) : _vm._e()], 2), _c('div', {
    staticClass: "p-2 border-top typebox"
  }, [_vm.showIndicator ? _c('div', {
    staticClass: "position-absolute unread d-flex justify-content-center px-3"
  }, [_vm.unread ? _c('b-button', {
    attrs: {
      "variant": "dark",
      "size": "sm",
      "pill": ""
    },
    on: {
      "click": _vm.scrollToBottom
    }
  }, [_c('div', {
    staticClass: "last-message-wrapper"
  }, [_vm._v(" " + _vm._s(_vm.latestMessage.sender.name) + "：" + _vm._s(_vm.latestMessage.content) + " ")])]) : !_vm.bottom ? _c('b-button', {
    staticClass: "px-2",
    attrs: {
      "variant": "dark",
      "size": "sm",
      "pill": ""
    },
    on: {
      "click": _vm.scrollToBottom
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512",
      "height": "16",
      "fill": "white"
    }
  }, [_c('path', {
    attrs: {
      "d": "M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"
    }
  })])]) : _vm._e()], 1) : _vm._e(), _vm.allowSendMessage || _vm.allowSendImage || _vm.allowSendFile ? _c('div', {
    staticClass: "d-flex"
  }, [_c('b-modal', {
    ref: "imageModal",
    staticClass: "modal-image",
    attrs: {
      "id": "modal-image-upload",
      "title": "傳送照片",
      "centered": "",
      "hide-footer": ""
    }
  }, [_vm.uploading ? _c('div', [_vm._v("上傳中...")]) : _c('b-form-file', {
    ref: "imageUploader",
    staticClass: "uploader",
    attrs: {
      "drop-placeholder": "Drop file here...",
      "accept": "image/*",
      "multiple": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "input": _vm.handleUpload
    },
    scopedSlots: _vm._u([{
      key: "file-name",
      fn: function fn(_ref) {
        var names = _ref.names;
        return [_c('b-badge', {
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v(_vm._s(names[0]))])];
      }
    }], null, false, 3778198266)
  }, [_c('template', {
    slot: "placeholder"
  }, [_c('div', {
    staticClass: "\n                    dropzone\n                    d-flex\n                    flex-column\n                    align-items-center\n                    justify-content-center\n                  "
  }, [_c('div', [_vm._v("請將檔案拖放至此")]), _c('div', [_vm._v("或")]), _c('div', [_vm._v("選擇檔案")])])])], 2)], 1), _c('b-modal', {
    ref: "fileModal",
    staticClass: "modal-image",
    attrs: {
      "id": "modal-file-upload",
      "title": "傳送檔案",
      "centered": "",
      "hide-footer": ""
    }
  }, [_vm.uploading ? _c('div', [_vm._v("上傳中...")]) : _c('b-form-file', {
    ref: "fileUploader",
    staticClass: "uploader",
    attrs: {
      "drop-placeholder": "Drop file here...",
      "multiple": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "input": _vm.handleUpload
    },
    scopedSlots: _vm._u([{
      key: "file-name",
      fn: function fn(_ref2) {
        var names = _ref2.names;
        return [_c('b-badge', {
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v(_vm._s(names[0]))])];
      }
    }], null, false, 3778198266)
  }, [_c('template', {
    slot: "placeholder"
  }, [_c('div', {
    staticClass: "\n                    dropzone\n                    d-flex\n                    flex-column\n                    align-items-center\n                    justify-content-center\n                  "
  }, [_c('div', [_vm._v("請將檔案拖放至此")]), _c('div', [_vm._v("或")]), _c('div', [_vm._v("選擇檔案")])])])], 2)], 1), _vm.canShowChatReply && _vm.selectedChatroom ? [_vm.allowSendImage ? _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-image-upload",
      modifiers: {
        "modal-image-upload": true
      }
    }],
    staticClass: "btn btn-link px-2 text-dark",
    attrs: {
      "disabled": !_vm.selectedChatroom.is_enabled
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm.allowSendFile ? _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-file-upload",
      modifiers: {
        "modal-file-upload": true
      }
    }],
    staticClass: "btn btn-link px-2 text-dark",
    attrs: {
      "disabled": !_vm.selectedChatroom.is_enabled
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _c('form', {
    staticClass: "flex-fill message-form",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_vm.allowSendMessage ? _c('b-form-textarea', {
    ref: "input",
    staticClass: "message-box",
    style: "--lines: ".concat(_vm.messageLines),
    attrs: {
      "placeholder": _vm.selectedChatroom.is_enabled ? '輸入留言' : '聊天室已關閉',
      "disabled": !_vm.selectedChatroom.is_enabled,
      "rows": "1"
    },
    on: {
      "keypress": _vm.handleInputKeypress
    },
    model: {
      value: _vm.message,
      callback: function callback($$v) {
        _vm.message = $$v;
      },
      expression: "message"
    }
  }) : _vm._e(), _vm.allowSendMessage ? _c('button', {
    staticClass: "btn send",
    attrs: {
      "type": "button",
      "disabled": _vm.sending || !_vm.selectedChatroom.is_enabled
    },
    on: {
      "click": _vm.send
    }
  }, [_c('svg', {
    attrs: {
      "width": "21",
      "height": "18",
      "viewBox": "0 0 21 18",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19.17 6.22991L5.17001 0.449907C4.64029 0.230693 4.05884 0.167851 3.49451 0.26882C2.93018 0.369788 2.4066 0.630339 1.98575 1.01963C1.5649 1.40891 1.2644 1.91064 1.11983 2.4654C0.975262 3.02016 0.992675 3.60473 1.17001 4.14991L2.71001 8.99991L1.13001 13.8499C0.947881 14.3973 0.927422 14.9855 1.07108 15.5442C1.21475 16.1029 1.51644 16.6083 1.94001 16.9999C2.48465 17.505 3.19729 17.79 3.94001 17.7999C4.33474 17.7996 4.72554 17.7215 5.09001 17.5699L19.14 11.7899C19.6872 11.5623 20.1547 11.1778 20.4836 10.6848C20.8125 10.1919 20.988 9.61252 20.988 9.01991C20.988 8.42729 20.8125 7.84795 20.4836 7.35497C20.1547 6.862 19.6872 6.47747 19.14 6.24991L19.17 6.22991ZM4.36001 15.6999C4.18361 15.7727 3.99007 15.7934 3.80225 15.7598C3.61442 15.7261 3.44015 15.6394 3.30001 15.5099C3.168 15.3838 3.07304 15.2239 3.02545 15.0476C2.97785 14.8713 2.97943 14.6854 3.03001 14.5099L4.49001 9.99991H18.22L4.36001 15.6999ZM4.49001 7.99991L3.00001 3.52991C2.94943 3.35446 2.94785 3.16851 2.99545 2.99222C3.04304 2.81594 3.138 2.65606 3.27001 2.52991C3.36412 2.43118 3.47742 2.35275 3.60296 2.29944C3.7285 2.24613 3.86362 2.21906 4.00001 2.21991C4.13406 2.22016 4.26669 2.24737 4.39001 2.29991L18.22 7.99991H4.49001Z",
      "fill": "#09101D"
    }
  })])]) : _vm._e()], 1)] : _vm._e()], 2) : _vm._e()])]), _vm.selectedChatroom ? _c('div', {
    staticClass: "sidebox"
  }, [_c('div', {
    staticClass: "py-3 h-100"
  }, [_vm.selectedChatroom && false ? _c('div', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "text-center p-3"
  }, [_c('b-avatar', {
    staticClass: "my-4",
    attrs: {
      "size": "13rem",
      "src": _vm.getChatroomAvatar(_vm.selectedChatroom)
    }
  }), _c('div', {
    staticClass: "h4 p-2"
  }, [_vm._v(" " + _vm._s(_vm.getChatroomTitle(_vm.selectedChatroom, true)) + " "), _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-name",
      modifiers: {
        "modal-name": true
      }
    }],
    staticClass: "btn h4"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _c('div', {
    staticClass: "tags"
  }, [_vm._l(_vm.tags, function (i) {
    return _c('b-badge', {
      key: i,
      staticClass: "m-1",
      attrs: {
        "variant": "dark"
      }
    }, [_vm._v(_vm._s(i))]);
  }), _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-tags",
      modifiers: {
        "modal-tags": true
      }
    }],
    staticClass: "btn"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)], 1), _c('b-list-group', {
    staticClass: "border-top border-bottom accordion",
    attrs: {
      "id": "accordionExample",
      "flush": ""
    }
  }, [_c('b-list-group-item', {
    staticClass: "d-flex justify-content-between align-items-center",
    attrs: {
      "role": "button"
    }
  }, [_c('div', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-profile",
      modifiers: {
        "collapse-profile": true
      }
    }],
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_vm._v(" 記事本 "), _c('i', {
    staticClass: "fa fa-chevron-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('b-collapse', {
    staticClass: "py-3",
    attrs: {
      "id": "collapse-profile"
    }
  }, [_c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-note",
      modifiers: {
        "modal-note": true
      }
    }],
    staticClass: "btn"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" " + _vm._s(_vm.customerProfile.note) + " ")])], 1), _c('b-list-group-item', {
    attrs: {
      "role": "button"
    }
  }, [_c('div', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-profile",
      modifiers: {
        "collapse-profile": true
      }
    }],
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_vm._v(" 基本資料 "), _c('i', {
    staticClass: "fa fa-chevron-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('b-collapse', {
    staticClass: "py-3",
    attrs: {
      "id": "collapse-profile"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputPhone"
    }
  }, [_vm._v("行動電話")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "InputPhone",
      "placeholder": "請使用 0-9,+,-組合的電話號碼格式"
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputEmail"
    }
  }, [_vm._v("電子信箱")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "InputEmail",
      "placeholder": "請輸入電子信箱"
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputBirthday"
    }
  }, [_vm._v("生日")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "InputBirthday",
      "placeholder": "日期格式為西元年月日，如 1990-01-01"
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputGender"
    }
  }, [_vm._v("性別")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "InputGender",
      "placeholder": "性別"
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputLanguage"
    }
  }, [_vm._v("語言")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "InputLanguage",
      "placeholder": "語言"
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputCountry"
    }
  }, [_vm._v("國家")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "InputCountry",
      "placeholder": "國家"
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputCity"
    }
  }, [_vm._v("現居城市")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "InputCity",
      "placeholder": "現居城市"
    }
  })])])], 1)], 1)], 1) : _vm._e(), _vm.showMemberListInDashboard || _vm.showFileListInDashboard ? _c('b-tabs', {
    staticClass: "h-100"
  }, [_vm.showMemberListInDashboard ? _c('b-tab', {
    attrs: {
      "title": "成員",
      "title-item-class": "pl-2"
    }
  }, [!_vm.selectedMember ? _c('b-list-group', [_vm.loading ? _c('div', {
    staticClass: "text-center mt-3 mb-3 loading-spinner"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1) : _c('div', [_vm.canShowAddMemberButton ? _c('ChatroomAddMember', {
    attrs: {
      "chatroom": _vm.selectedChatroom,
      "disabled": _vm.disabledAddMemberButton
    },
    on: {
      "added": function added($event) {
        _vm.fetchCustomers();
        _vm.fetchStaffs();
        _vm.fetchSingleChatroom();
      }
    }
  }) : _vm._e(), _vm._l(_vm.staffs, function (staff) {
    return _c('b-list-group-item', {
      key: staff.id,
      staticClass: "d-flex align-items-center border-0",
      attrs: {
        "href": "#"
      }
    }, [_c('b-avatar', {
      staticClass: "mr-1",
      attrs: {
        "src": staff.avatar_url
      }
    }), _c('div', {
      staticClass: "\n                      mr-auto\n                      font-weight-bold\n                      text-nowrap text-truncate\n                      pr-2\n                    "
    }, [_vm._v(" " + _vm._s(staff.name) + " ")]), _c('div', {
      staticClass: "text-nowrap"
    }, [_vm.chatroomConfig.invite_staff_in_dashboard_permission_role && _vm.canShowRemoveMemberButton && staff.role !== _vm.chatroomConfig.invite_staff_in_dashboard_permission_role ? _c('b-button', {
      staticClass: "p-1 mr-2",
      attrs: {
        "size": "xs",
        "pill": "",
        "variant": "danger"
      },
      on: {
        "click": function click($event) {
          return _vm.removeMember(staff);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times m-0"
    })]) : _vm._e()], 1)], 1);
  }), _vm._l(_vm.customers, function (customer) {
    return _c('b-list-group-item', {
      key: customer.id,
      staticClass: "d-flex align-items-center border-0",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function click($event) {
          return _vm.handleSelectMember(customer.id);
        }
      }
    }, [_c('b-avatar', {
      staticClass: "mr-1",
      attrs: {
        "src": customer.avatar_url
      }
    }), _c('div', {
      staticClass: "\n                      mr-auto\n                      font-weight-bold\n                      text-nowrap text-truncate\n                      pr-2\n                    "
    }, [_vm._v(" " + _vm._s(customer.name) + " ")]), _c('div', {
      staticClass: "text-nowrap"
    }, [_c('i', {
      staticClass: "fa fa-angle-right",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1);
  })], 2)]) : _vm._e(), _vm.selectedMember ? _c('div', {
    staticClass: "profile"
  }, [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": function click($event) {
        _vm.selectedMember = false;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 回列表 ")]), _c('div', {
    staticClass: "text-center p-3"
  }, [_c('b-avatar', {
    staticClass: "my-4",
    attrs: {
      "size": "8rem",
      "src": _vm.customer.avatar_url
    }
  }), _c('div', {
    staticClass: "h4 p-2 text-left"
  }, [_c('h6', {
    staticClass: "mb-2"
  }, [_vm._v("LINE 名稱：" + _vm._s(_vm.customer.name))]), _c('h6', {
    staticClass: "m-0"
  }, [_vm._v(" 自訂暱稱：" + _vm._s(_vm.customerProfile.nickname)), _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-nickname",
      modifiers: {
        "modal-nickname": true
      }
    }],
    staticClass: "btn m-0",
    attrs: {
      "hidden": !_vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE)
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _c('h6', {
    staticClass: "m-0"
  }, [_vm._v(" 姓名：" + _vm._s(_vm.customerProfile.name)), _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-name",
      modifiers: {
        "modal-name": true
      }
    }],
    staticClass: "btn m-0",
    attrs: {
      "hidden": !_vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE)
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _c('h6', {
    staticClass: "mb-2"
  }, [_vm._v(" 身份證字號：" + _vm._s(_vm.customerProfile.personal_id)), _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-personal-id",
      modifiers: {
        "modal-personal-id": true
      }
    }],
    staticClass: "btn m-0",
    attrs: {
      "hidden": !_vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE)
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _c('div', {
    staticClass: "tags"
  }, [_c('h6', {
    staticClass: "m-0"
  }, [_vm._v("標籤：")]), _vm._l(_vm.tagsOriginal, function (tag) {
    return _c('b-badge', {
      key: tag.id,
      staticClass: "m-1",
      attrs: {
        "variant": "dark"
      }
    }, [_vm._v(_vm._s(tag.name))]);
  }), _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-tags",
      modifiers: {
        "modal-tags": true
      }
    }],
    staticClass: "btn",
    attrs: {
      "hidden": !_vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE)
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)])], 1), _c('b-list-group', {
    staticClass: "border-top border-bottom accordion",
    attrs: {
      "id": "accordionExample",
      "flush": ""
    }
  }, [_c('b-list-group-item', {
    attrs: {
      "role": "button"
    }
  }, [_c('div', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-note",
      modifiers: {
        "collapse-note": true
      }
    }],
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_vm._v(" 自訂筆記 "), _c('i', {
    staticClass: "fa fa-chevron-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('b-collapse', {
    staticClass: "py-3",
    attrs: {
      "id": "collapse-note"
    }
  }, [_c('div', {
    staticStyle: {
      "white-space": "break-spaces"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.customerProfile.note)
    }
  }), _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-note",
      modifiers: {
        "modal-note": true
      }
    }],
    staticClass: "btn",
    attrs: {
      "hidden": !_vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE)
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1), _c('b-list-group-item', {
    attrs: {
      "role": "button"
    }
  }, [_c('div', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-profile",
      modifiers: {
        "collapse-profile": true
      }
    }],
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_vm._v(" 基本資料 "), _c('i', {
    staticClass: "fa fa-chevron-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('b-collapse', {
    staticClass: "py-3",
    attrs: {
      "id": "collapse-profile"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputPhone"
    }
  }, [_vm._v("行動電話")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.customer.mobile_phone,
      expression: "customer.mobile_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "InputPhone",
      "placeholder": "請使用 0-9,+,-組合的電話號碼格式",
      "disabled": !_vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE)
    },
    domProps: {
      "value": _vm.customer.mobile_phone
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "mobile_phone", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputEmail"
    }
  }, [_vm._v("電子信箱")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.customer.email,
      expression: "customer.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "InputEmail",
      "placeholder": "請輸入電子信箱",
      "disabled": !_vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE)
    },
    domProps: {
      "value": _vm.customer.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "email", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputBirthday"
    }
  }, [_vm._v("生日")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.customer.birthday,
      expression: "customer.birthday"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "InputBirthday",
      "placeholder": "日期格式為西元年月日，如 1990-01-01",
      "disabled": !_vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE)
    },
    domProps: {
      "value": _vm.customer.birthday
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "birthday", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputGender"
    }
  }, [_vm._v("性別")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.customer.sexual,
      expression: "customer.sexual"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "InputGender",
      "placeholder": "性別",
      "disabled": !_vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE)
    },
    domProps: {
      "value": _vm.customer.sexual
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "sexual", $event.target.value);
      }
    }
  })]), false ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputLanguage"
    }
  }, [_vm._v("語言")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.customer.language,
      expression: "customer.language"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "InputLanguage",
      "placeholder": "語言",
      "disabled": !_vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE)
    },
    domProps: {
      "value": _vm.customer.language
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "language", $event.target.value);
      }
    }
  })]) : _vm._e(), false ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputCountry"
    }
  }, [_vm._v("國家")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "InputCountry",
      "placeholder": "國家",
      "disabled": !_vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE)
    }
  })]) : _vm._e(), false ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputCity"
    }
  }, [_vm._v("現居城市")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "InputCity",
      "placeholder": "現居城市",
      "disabled": !_vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE)
    }
  })]) : _vm._e(), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "hidden": !_vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_CHAT_MODIFY_CUSTOMER_PROFILE)
    },
    on: {
      "click": _vm.handleClickSaveCustomer
    }
  }, [_vm._v(" 儲存 ")])])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm.showFileListInDashboard ? _c('b-tab', {
    attrs: {
      "title": "檔案",
      "title-item-class": "pr-2"
    },
    on: {
      "click": _vm.fetchFileList
    }
  }, [_c('b-list-group', [_vm.loading ? _c('div', {
    staticClass: "text-center mt-3 mb-3 loading-spinner"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1) : _c('div', _vm._l(_vm.fileList, function (file, i) {
    return _c('b-list-group-item', {
      key: i,
      staticClass: "d-flex align-items-center border-0",
      attrs: {
        "href": _vm.catFileType(file.mime) === 'jpg' ? '' : file.url
      }
    }, [_vm.catFileType(file.mime) === 'csv' ? _c('img', {
      staticClass: "mr-2 file-type-icon",
      attrs: {
        "src": require("@/assets/images/file_type_icons/csv.png")
      }
    }) : _vm._e(), _vm.catFileType(file.mime) === 'doc' ? _c('img', {
      staticClass: "mr-2 file-type-icon",
      attrs: {
        "src": require("@/assets/images/file_type_icons/doc.png")
      }
    }) : _vm._e(), _vm.catFileType(file.mime) === 'file' ? _c('img', {
      staticClass: "mr-2 file-type-icon",
      attrs: {
        "src": require("@/assets/images/file_type_icons/file.png")
      }
    }) : _vm._e(), _vm.catFileType(file.mime) === 'jpg' ? _c('img', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-showImg",
        modifiers: {
          "modal-showImg": true
        }
      }],
      staticClass: "mr-2 file-type-icon",
      attrs: {
        "src": file.url
      },
      on: {
        "click": function click($event) {
          _vm.currentImg = file.url;
        }
      }
    }) : _vm._e(), _vm.catFileType(file.mime) === 'pdf' ? _c('img', {
      staticClass: "mr-2 file-type-icon",
      attrs: {
        "src": require("@/assets/images/file_type_icons/pdf.png")
      }
    }) : _vm._e(), _vm.catFileType(file.mime) === 'ppt' ? _c('img', {
      staticClass: "mr-2 file-type-icon",
      attrs: {
        "src": require("@/assets/images/file_type_icons/ppt.png")
      }
    }) : _vm._e(), _vm.catFileType(file.mime) === 'txt' ? _c('img', {
      staticClass: "mr-2 file-type-icon",
      attrs: {
        "src": require("@/assets/images/file_type_icons/txt.png")
      }
    }) : _vm._e(), _vm.catFileType(file.mime) === 'xls' ? _c('img', {
      staticClass: "mr-2 file-type-icon",
      attrs: {
        "src": require("@/assets/images/file_type_icons/xls.png")
      }
    }) : _vm._e(), _vm.catFileType(file.mime) === 'zip' ? _c('img', {
      staticClass: "mr-2 file-type-icon",
      attrs: {
        "src": require("@/assets/images/file_type_icons/zip.png")
      }
    }) : _vm._e(), _c('div', {
      staticClass: "d-flex flex-column lh-sm-0 text-truncate"
    }, [_c('div', {
      staticClass: "mr-auto font-weight-bold"
    }, [_vm._v(" " + _vm._s(file.name) + " ")]), _c('div', {
      staticClass: "small text-muted"
    }, [_vm._v(_vm._s(file.sender.name))]), _c('div', {
      staticClass: "small text-muted"
    }, [_vm._v(_vm._s(_vm.formatDateD(file.created_at)))])])]);
  }), 1)]), _c('b-pagination', {
    staticClass: "separated mb-2 mb-md-0 align-self-center",
    attrs: {
      "total-rows": _vm.total,
      "per-page": _vm.perPage
    },
    on: {
      "change": _vm.handleChangePage
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1)]) : _vm._e()]), _c('ImageLightBox', {
    ref: "lightbox"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }